import {registerTileSchema} from '#core/application/schema-registry.js';

import {generateSecondaryLink} from '../link/index.js';

import EMPTY_CONTENT_MESSAGE from './empty-content-message.palette-schema.yaml';

registerTileSchema(EMPTY_CONTENT_MESSAGE);

export function generateEmptyContentMessage(TILE) {
    return {
        text: {
            container: {
                padding: 0, // Override mojito default
            },
            style: {
                textAlign: 'center',
                ...TILE.EMPTY_CONTENT_MESSAGE_TEXT,
            },
        },
        button: generateSecondaryLink(TILE.LINK),
    };
}
